import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CovidMeasuresConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	covidMeasuresEnabled(): boolean {
		return this.configService.get((x) => x.core.covidMeasures.isEnabled, false);
	}
}
